/**
 * Identificador de login dual (correo O teléfono) — paridad con el login del RBAC
 * (DEC-RBAC-079/080/081). Funciones puras. Fuente única de la regla de validación
 * para que el login y la recuperación de contraseña no diverjan.
 * Teléfono: `+` opcional + 10-15 dígitos (E.164). Sin normalizar: se manda el string crudo.
 */

/** Regex de teléfono E.164: `+` opcional y 10-15 dígitos. */
export const PHONE_E164_REGEX = /^\+?\d{10,15}$/;

/** Es email si contiene `@` (misma heurística que el RBAC). */
export function isEmail(value: string): boolean {
  return value.includes("@");
}

/** Válido si es email (tiene `@`) o si matchea E.164. */
export function validateIdentifier(value: string): boolean {
  const v = value.trim();
  if (v.length === 0) return false;
  return isEmail(v) || PHONE_E164_REGEX.test(v);
}
